var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"ui-search"},[_c('v-icon',{attrs:{"size":"18"}},[_vm._v("mdi-magnify")]),_c('input',{ref:"input",attrs:{"type":"search","placeholder":_vm.placeholder,"aria-label":_vm.label || _vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }